/**
 * TC-A2 — helpers for "sign in from anywhere and land back where you were".
 * The sanitizer is the single chokepoint against open-redirects: a returnUrl is
 * only honoured when it is an in-app path under THIS store's token, never an
 * external/absolute/protocol-relative URL, a different store, or a /login loop.
 */

/** Router commands for the guard-free login route. */
export function loginCommands(token: string): string[] {
  return ['/t', token, 'login'];
}

/**
 * Accept only same-app paths under `/t/<token>/…` (or the landing `/t/<token>`).
 * Returns the safe path, or null when the input is missing/unsafe.
 */
export function sanitizeReturnUrl(raw: string | null | undefined, token: string): string | null {
  if (!raw || !token) return null;
  if (!raw.startsWith('/')) return null;            // must be app-relative
  if (raw.startsWith('//')) return null;            // protocol-relative (//evil.com) → reject
  if (raw.includes('\\')) return null;              // backslash tricks → reject

  const base = `/t/${token}`;
  const path = raw.split(/[?#]/)[0];                // compare without query/fragment
  if (path !== base && !path.startsWith(`${base}/`)) return null;  // same store only

  // Never bounce back into a login screen (would loop on success).
  if (path === `${base}/login` || path.startsWith(`${base}/delivery/login`)) return null;

  return raw;
}
